import React from 'react';
import { URLS } from '@wix/da-url';
import LoadingIndicator from '../../../LoadingIndicator';
import StreamedList from '../../../StreamedList';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import GroupListItem from './GroupListItem/GroupListItem';
import { useTranslation } from 'react-i18next';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import s from './GroupsList.scss';
var GroupsList = function (_a) {
    var headerContent = _a.headerContent, groups = _a.groups, onSelect = _a.onSelect, isFetching = _a.isFetching, streamId = _a.streamId, filterValue = _a.filterValue;
    var t = useTranslation().t;
    var isEmpty = !isFetching && groups.length === 0;
    return isFetching && !groups.length ? (React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })) : (React.createElement(React.Fragment, null,
        headerContent,
        !isEmpty ? (React.createElement(StreamedList, { streamId: streamId, className: s['list'], wrapperClassName: s['scrollable'] }, groups.map(function (group) {
            return !filterValue ||
                group.username.toLowerCase().includes(filterValue.toLowerCase()) ? (React.createElement(BiButton, { key: group.userId, className: s['list-item'], onClick: function () { return onSelect(group); }, biData: {
                    evid: BiEventType.ADD_TO_GROUP_SELECT,
                    groupid: group.useridUuid,
                } },
                React.createElement(GroupListItem, { group: group }))) : null;
        }))) : (React.createElement(Section, { className: s['empty'] },
            React.createElement(Heading, { className: s['empty-header'] }, t('addToGroupPopup.empty.header')),
            React.createElement("div", { className: s['empty-text'] }, t('addToGroupPopup.empty.text')),
            React.createElement(GhostButton, { className: s['empty-cta-button'], variant: "approval-green", size: "medium", href: URLS.GROUPS, biData: BiData({
                    evid: 2,
                    click_info: 'addToGroup.emptyState',
                    sectionname: BiContextProvidedValue,
                    widgetname: BiContextProvidedValue,
                    typeid: BiContextProvidedValue,
                    itemid: BiContextProvidedValue,
                }) }, t('addToGroupPopup.empty.CTA.button'))))));
};
GroupsList.displayName = 'GroupsList';
export default GroupsList;
//# sourceMappingURL=GroupsList.js.map